import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../hooks'
import { FormikField, getFormikFormFieldErrorProps } from '../../Formik'
import { TextareaInlineField } from '../../Textarea'
import { NEWSBOARD_POST_TICKER_MESSAGE_MAX_LENGTH } from '../Newsboard.constants'

import { NewsboardMessageFieldEditor } from './NewsboardMessageFieldEditor'

function NewsboardMessageField({
  autoFocus,
  name,
  skipFieldWrapper,
  ticker,
  ...restProps
}) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return ticker ? (
    <FormikField
      clearable
      Component={TextareaInlineField}
      Field={skipFieldWrapper ? Fragment : undefined}
      autoFocus={autoFocus}
      borderless={!isMobileScreenSize}
      fieldComponentProps={
        skipFieldWrapper
          ? undefined
          : {
              label: `${t('Newsboard.MessageLabelKey')}:`,
              required: true,
              shouldAdaptToMobileScreen: true,
            }
      }
      getErrorProps={getFormikFormFieldErrorProps}
      label={t('Newsboard.MessageFieldPlaceholderKey')}
      maxLength={NEWSBOARD_POST_TICKER_MESSAGE_MAX_LENGTH}
      name={name}
      placeholder={t('Newsboard.MessageFieldPlaceholderKey')}
    />
  ) : (
    <NewsboardMessageFieldEditor
      {...restProps}
      autoFocus={autoFocus}
      name={name}
      skipFieldWrapper={skipFieldWrapper}
    />
  )
}

export default NewsboardMessageField
